export const SOLANA_WALLET_LOCAL_STORAGE_KEY = 'walletName'

export const SOLANA_RPC_ENDPOINT =
  import.meta.env.VITE_SOLANA_RPC_URL ?? 'https://api.devnet.solana.com'

export const SOLANA_NETWORK = (import.meta.env.VITE_SOLANA_NETWORK ??
  'devnet') as 'devnet' | 'mainnet-beta'
